import React, { useState, Fragment, useEffect } from 'react';
import styled from 'styled-components';
import { string, func, bool } from 'prop-types';
import { Icon } from 'semantic-ui-react';

import { headerHeightMobile, colors } from '../../styles';
import MenuItem from '../Menu/MenuItem';
import { Routes } from '../../routing';

const MobileDropdownContainer = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  top: ${({ visible }) => (visible ? headerHeightMobile : 0)}rem;
  width: 100%;
  position: fixed;
  z-index: 5;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.35);
  background: ${colors.white};
  transition: top 0.3s;
`;

const Username = styled.li`
  padding: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: ${colors.green};
`;

const ArrowIcon = styled(Icon)`
  color: ${colors.darkBlack};
`;

const MobileDropdown = ({ username, logOut, showRep }) => {
  const [showItems, setShowItems] = useState(false);
  const [prevScrollpos, setPrevScrollpos] = useState(window.pageYOffset);
  const [visible, setVisible] = useState(true);

  // hide dropdown when scroll down
  const handleScroll = () => {
    const currentScrollPos = window.pageYOffset;
    // set a minimun height to avoid closing on mobile browser bouncing AS-1318
    const isVisible = currentScrollPos < 30 || prevScrollpos > currentScrollPos;

    setPrevScrollpos(currentScrollPos);
    setVisible(isVisible);

    // fold dropdown items when scrolling down
    if (!isVisible) {
      setShowItems(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    // clean up
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  return (
    <MobileDropdownContainer visible={visible}>
      <Username
        data-qa="button-top-navigation-logout"
        onClick={() => setShowItems(!showItems)}
      >
        <span>{username}</span>
        <ArrowIcon name={`angle ${showItems ? 'up' : 'down'}`} />
      </Username>
      {showItems && (
        <Fragment>
          {showRep && <MenuItem simple title="My AGI Rep" url={Routes.rep} />}

          <MenuItem simple title="Logout" onClick={logOut} />
        </Fragment>
      )}
    </MobileDropdownContainer>
  );
};

MobileDropdown.propTypes = {
  username: string,
  logOut: func.isRequired,
  showRep: bool
};

export default MobileDropdown;



// WEBPACK FOOTER //
// ./src/components/TopNavigation/MobileDropdown.js